import React, { useEffect } from 'react';
import { LoadingSpinner } from 'components/spinner/loading-spinner.component';
import { handleLoginRedirect } from 'utils/handle-login-redirect.util';
import { resetCareManagementModalState } from 'utils/reset-care-management-modal-state';

export const AuthSignIn = () => {
  useEffect(() => {
    handleLoginRedirect();
    resetCareManagementModalState();
  }, []);

  return <LoadingSpinner />;
};
